import { ErrorFallback } from '@client/components/_core/error-handling/ErrorFallback';
import { errorMessage } from '@client/components/_ui/feedback/error-message/ErrorMessage';
import { message } from '@client/components/_ui/feedback/message';
import { modal } from '@client/components/_ui/feedback/modal';
import { OfflineOverlay } from '@client/components/_ui/feedback/OfflineOverlay';
import { useAppBuildVersion } from '@client/hooks/system/useAppBuildVersion';
import { useBrowserCompatibility } from '@client/hooks/system/useBrowserCompatibility';
import { useFingerprint } from '@client/hooks/system/useFingerprint';
import { useInMaintenance } from '@client/hooks/system/useInMaintenance';
import { useIsDebugInfoEnabled } from '@client/hooks/system/useIsDebugInfoEnabled';
import { useOfflineDetection } from '@client/hooks/system/useOfflineDetection';
import { useBodyClass } from '@client/hooks/ui/useBodyClass';
import { useDocumentTitle } from '@client/hooks/ui/useDocumentTitle';
import * as Sentry from '@sentry/react';
import { Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const DebugInfo = lazy(() => import('@client/components/_ui/utils/DebugInfo').then((m) => ({ default: m.DebugInfo })));

export function AppProvider() {
    const isDebugInfoEnabled = useIsDebugInfoEnabled();
    useBrowserCompatibility();
    useOfflineDetection();
    useDocumentTitle();
    useAppBuildVersion();
    useInMaintenance();
    useFingerprint();
    useBodyClass();
    errorMessage.init(modal, message);

    return (
        <Sentry.ErrorBoundary fallback={ErrorFallback}>
            <OfflineOverlay />
            <Outlet />
            {isDebugInfoEnabled && (
                <Suspense fallback={null}>
                    <DebugInfo />
                </Suspense>
            )}
        </Sentry.ErrorBoundary>
    );
}
